/** App Store / Play Store URLs — set via .env when listings are available */
export const APP_LINKS = {
  customer: {
    ios:
      process.env.REACT_APP_CUSTOMER_APP_STORE_URL ||
      "https://apps.apple.com/app/tydii",
    android:
      process.env.REACT_APP_CUSTOMER_PLAY_STORE_URL ||
      "https://play.google.com/store/apps/details?id=com.tydii.customer",
  },
  driver: {
    ios:
      process.env.REACT_APP_DRIVER_APP_STORE_URL ||
      "https://apps.apple.com/app/tydii-driver",
    android:
      process.env.REACT_APP_DRIVER_PLAY_STORE_URL ||
      "https://play.google.com/store/apps/details?id=com.tydii.driver",
  },
};
